import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://quantumtrades.com.br:8080";

const api = axios.create({
  baseURL,
  timeout: 15000,
});

// Interceptor de request — injeta token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor de response — detecta 401 e redireciona para login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname;

      // Não redireciona se já estiver no login ou cadastro
      if (currentPath !== "/login" && currentPath !== "/cadastro") {
        localStorage.removeItem("authToken");
        window.location.href = "/login?sessao=expirada";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
